var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add Supplies"},on:{"on-hide":_vm.resetFormData}},[_c('supplies-form',{key:_vm.formKey,attrs:{"vendor":_vm.vendor,"vendor_id":_vm.vendorId,"client":_vm.client,"client_id":_vm.clientId},on:{"on-submit":_vm.createSupply,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }